<div class="app-profile" [ngClass]="httpService.theme">
    <cf-tabs [theme]="httpService.theme" [tabs]="tabs" [currentTab]="currentTab"
        (changed)="changeTab($event)"></cf-tabs>

    <div class="tabs">
        <app-personal-profile *ngIf="currentTab === 'personal-profile'"> </app-personal-profile>
        <app-payout-beneficiaries *ngIf="currentTab === 'beneficiary'"> </app-payout-beneficiaries>
    </div>
</div>